export default __webpack_public_path__ + "static/media/nuts.804fa46b.webp";